import React from 'react';

const Details = () => {
  return (
    <section className="details">
      <div>
        <h3>Precision-Matched Resumes</h3>
        <p>Ensure your resume is a perfect fit for every opportunity</p>
      </div>
      <div>
        <h3>Instantly Impressive</h3>
        <p>Create flawless, recruiter-approved resumes in minutes</p>
      </div>
      <div>
        <h3>Effortless Adaptability</h3>
        <p>The perfect resume is just a few clicks away. Get yours now!</p>
      </div>
    </section>
  );
};

export default Details;
